import {Button} from '@primer/react'
import {ForYouItem} from '../shared/ForYouItem'
import {decideChecksItem} from './shared/checks-item-decider'
import {useMergeabilityData} from './use-mergeability-data'
import {StatusCheckStatesIcon} from '@github-ui/mergebox/components/sections/checks/StatusCheckStatesIcon'

// Renders when checks are still running and no workflow approval is pending
export function PendingChecks({variant}: {variant?: 'default' | 'embedded'}) {
  const data = useMergeabilityData()

  if (!data || decideChecksItem(data).kind !== 'pending') {
    return null
  }

  const {statusRollup} = data

  return (
    <ForYouItem
      leadingVisual={<StatusCheckStatesIcon statusRollupSummary={statusRollup.summary} size={24} />}
      emphasizedLeadingVisual
      title="Checks running"
      itemName="pending-checks"
      padding="none"
      variant={variant}
      description="Wait for the required checks to finish."
      actionSlot={
        <Button size="small" variant="default" inactive>
          Merge when ready
        </Button>
      }
    />
  )
}
